import React from "react";
import infoIcon from '../images/info.svg'

const ErrorNotificationContainer = ({
  translate,
  kitchenConnectionUp,
  lastServiceError
}) => {
  function getDisplayError() {
    if (!kitchenConnectionUp) {
      return "CheckConnection";
    }

    return lastServiceError;
  }

  const errorText = getDisplayError();

  if (!errorText) {
    return <React.Fragment />;
  }

  return (
    <div className="footer">
        <div className="flex-container display-card error-card">
            <img src={infoIcon} alt="warning"></img>
            <span>{translate(getDisplayError())}</span>
        </div>
    </div>
  );
};

export default ErrorNotificationContainer;



// WEBPACK FOOTER //
// ./src/containers/ErrorNotificationContainer.js